import React from 'react'
import { useFilters } from '../../context'
import { FilterType } from '../../types'
import { isColourFilter } from '../../utils'

interface Props {
  filter: FilterType
}

export const Filter: React.FC<Props> = ({ filter }) => {
  const filtersContext = useFilters()

  if (!filtersContext) return null
  const { activeFilters, setTitle, toggleFilter, setPage } = filtersContext

  if (filter.title === 'Clearance') return null

  const handleFilterChange = () => {
    setPage(1)
    setTitle('Leather Sofas & Armchairs')
    toggleFilter(filter.type, filter.title)
  }

  const isActive = activeFilters[filter.type].has(filter.title)
  const className = isActive ? '__checked' : null

  if (isColourFilter(filter)) {
    return (
      <li className="refinecolour">
        <label className={className}>
          <input
            type="checkbox"
            checked={isActive}
            onChange={handleFilterChange}
          />
          <div className="samplecoloursblock-block">
            <div className="styleblock __filter StyleBlock">
              <div className="styleblock-imgwrap">
                <img className="styleblock-img" src={filter.image} />
              </div>
              <p className="styleblock-title">{filter.colourTitle}</p>
            </div>
          </div>
        </label>
      </li>
    )
  }

  return (
    <li>
      <label className={className}>
        <input
          type="checkbox"
          checked={isActive}
          onChange={handleFilterChange}
        />
        {filter.title}
      </label>
    </li>
  )
}
